export class Category {
    company_category_id ? = '';
    company_sub_category_id ? = '';
    category_id ? = '';
    category_name ? = '';
    setting_code ? = '';
    setting_value ? = '';
    company_category ? = '';
    parent_id ? = '';
    sub_cat ? = '';
    due_date ? = '';
}


// WEBPACK FOOTER //
// ./src/app/type/category.ts